export default __webpack_public_path__ + "static/media/11.8c5d30bd.png";